// extracted by mini-css-extract-plugin
export default {"mainbodyfrm":"eventtwofrom_mainbodyfrm__jNiE5","widthContainer":"eventtwofrom_widthContainer__3b+Nr","active":"eventtwofrom_active__nCM6l","navlinks":"eventtwofrom_navlinks__NRHs3"};